<template>
  <div class="main-panel">
    <div class="content-wrapper constitucion-shell">
      <div class="cardplay constitucion-card">
        <div class="row constitucion-header g-3 align-items-center">
          <div class="col-12 col-lg-8">
            <h2 class="constitucion-title mb-1">Constitución</h2>
            <p class="constitucion-subtitle mb-0">Configura los datos institucionales usados en contratos.</p>
          </div>
        </div>

        <form class="form-card" @submit.prevent="saveConstitucion">
          <div v-if="loading" class="loading-shell">
            <span class="spinner-border spinner-border-sm" role="status"></span>
            Cargando constitución...
          </div>

          <div v-else>
            <div class="constitucion-type">
              <label class="type-option" :class="{ active: form.tipo === 'comerciante_individual' }">
                <input v-model="form.tipo" type="radio" value="comerciante_individual" />
                <span>
                  <strong>Comerciante Individual</strong>
                  <small>Persona natural que declara que ejercerá una actividad mercantil.</small>
                </span>
              </label>

              <label class="type-option" :class="{ active: form.tipo === 'sociedad_mercantil' }">
                <input v-model="form.tipo" type="radio" value="sociedad_mercantil" />
                <span>
                  <strong>Sociedad Mercantil</strong>
                  <small>Persona jurídica creada mediante documento de constitución.</small>
                </span>
              </label>
            </div>

            <div class="section-caption mt-4">Representante Legal</div>
            <div class="row g-3 mt-2">
              <div class="col-12 col-lg-6">
                <label class="form-label">Nombre</label>
                <input v-model.trim="form.representanteNombre" class="form-control" type="text" required />
              </div>
              <div class="col-12 col-lg-3">
                <label class="form-label">Estado Civil</label>
                <select v-model="form.representanteEstadoCivil" class="form-control">
                  <option value="">Seleccione</option>
                  <option v-for="estado in estadosCiviles" :key="estado" :value="estado">
                    {{ estado }}
                  </option>
                </select>
              </div>
              <div class="col-12 col-lg-3">
                <label class="form-label">Profesión</label>
                <input v-model.trim="form.representanteProfesion" class="form-control" type="text" />
              </div>
              <div class="col-12 col-lg-3">
                <label class="form-label">Nacionalidad</label>
                <input v-model.trim="form.representanteNacionalidad" class="form-control" type="text" required />
              </div>
              <div class="col-12 col-lg-3">
                <label class="form-label">Identidad</label>
                <input v-model.trim="form.representanteIdentidad" class="form-control" type="text" required />
              </div>
              <div class="col-12 col-lg-3">
                <label class="form-label">RTN</label>
                <input v-model.trim="form.representanteRtn" class="form-control" type="text" />
              </div>
              <div class="col-12 col-lg-3">
                <label class="form-label">Cargo</label>
                <input v-model.trim="form.representanteCargo" class="form-control" type="text" required />
              </div>
              <div class="col-12">
                <label class="form-label">Domicilio</label>
                <textarea v-model.trim="form.representanteDomicilio" class="form-control" rows="3"></textarea>
              </div>
            </div>

            <div v-if="form.tipo === 'sociedad_mercantil'" class="section-caption mt-4">Datos de la Sociedad Mercantil</div>
            <div v-if="form.tipo === 'sociedad_mercantil'" class="row g-3 mt-2">
              <div class="col-12 col-lg-6">
                <label class="form-label">Nombre Legal</label>
                <input v-model.trim="form.empresaNombreLegal" class="form-control" type="text" required />
              </div>
              <div class="col-12 col-lg-6">
                <label class="form-label">Nombre Corto</label>
                <input v-model.trim="form.empresaNombreCorto" class="form-control" type="text" />
              </div>
              <div class="col-12 col-lg-4">
                <label class="form-label">RTN</label>
                <input v-model.trim="form.empresaRtn" class="form-control" type="text" required />
              </div>
              <div class="col-12 col-lg-4">
                <label class="form-label">Teléfono</label>
                <input v-model.trim="form.empresaTelefono" class="form-control" type="text" />
              </div>
              <div class="col-12 col-lg-4">
                <label class="form-label">Email</label>
                <input v-model.trim="form.empresaEmail" class="form-control" type="email" />
              </div>
              <div class="col-12">
                <label class="form-label">Dirección</label>
                <textarea v-model.trim="form.empresaDireccion" class="form-control" rows="3"></textarea>
              </div>
            </div>

            <div class="form-actions">
              <button class="btn btn-primary constitucion-save-btn" type="submit" :disabled="saving">
                <span v-if="saving" class="spinner-border spinner-border-sm" role="status"></span>
                Guardar Constitución
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import Security from "../security";

export default {
  data() {
    return {
      loading: false,
      saving: false,
      estadosCiviles: [
        "soltero(a)",
        "casado(a)",
        "unión libre",
        "unión de hecho",
        "divorciado(a)",
        "viudo(a)",
        "separado(a)",
      ],
      form: this.emptyForm(),
    };
  },
  beforeMount() {
    Security.requireToken();
    this.loadConstitucion();
  },
  methods: {
    emptyForm() {
      return {
        id: 0,
        tipo: "comerciante_individual",
        representanteNombre: "",
        representanteEstadoCivil: "",
        representanteProfesion: "",
        representanteNacionalidad: "hondureño",
        representanteIdentidad: "",
        representanteRtn: "",
        representanteDomicilio: "",
        representanteCargo: "Representante Legal",
        empresaNombreLegal: "",
        empresaNombreCorto: "",
        empresaRtn: "",
        empresaDireccion: "",
        empresaTelefono: "",
        empresaEmail: "",
        activo: true,
      };
    },
    loadConstitucion() {
      this.loading = true;
      fetch(process.env.VUE_APP_API_URL + "/admin/constitucion/actual", Security.requestOptions({}))
        .then((response) => response.json())
        .then((response) => {
          if (response.error) {
            this.showError(response.message);
            return;
          }

          this.form = {
            ...this.emptyForm(),
            ...(response.data?.constitucion || {}),
          };
        })
        .catch((error) => this.showError(error))
        .finally(() => {
          this.loading = false;
        });
    },
    saveConstitucion() {
      const payload = { ...this.form };

      if (!payload.representanteNombre || !payload.representanteIdentidad) {
        this.showError("Nombre e identidad del representante son requeridos.");
        return;
      }

      if (payload.tipo === "sociedad_mercantil" && (!payload.empresaNombreLegal || !payload.empresaRtn)) {
        this.showError("Nombre legal y RTN de la empresa son requeridos.");
        return;
      }

      this.saving = true;
      fetch(process.env.VUE_APP_API_URL + "/admin/constitucion/save", Security.requestOptions(payload))
        .then((response) => response.json())
        .then((response) => {
          if (response.error) {
            this.showError(response.message);
            return;
          }

          this.form = {
            ...this.emptyForm(),
            ...(response.data?.constitucion || payload),
          };
          Swal.fire({
            icon: "success",
            title: "Constitución guardada",
            showConfirmButton: false,
            timer: 1200,
          });
        })
        .catch((error) => this.showError(error))
        .finally(() => {
          this.saving = false;
        });
    },
    showError(message) {
      Swal.fire({
        icon: "error",
        title: "No se pudo completar",
        text: String(message),
      });
    },
  },
};
</script>

<style scoped>
.constitucion-shell {
  background: linear-gradient(165deg, #f6f7fa 0%, #edf0f5 48%, #fafafa 100%);
  min-height: 100vh;
}

.cardplay {
  border-radius: 22px;
  border: 1px solid #e5e7eb;
  padding: 24px;
  background-color: #ffffff;
  box-shadow: 0 22px 54px rgba(15, 23, 42, 0.07);
}

.constitucion-header {
  background: linear-gradient(120deg, #20242b 0%, #343a43 72%, #4b5563 100%);
  border-radius: 16px;
  color: #fff;
  padding: 14px 16px;
  margin-bottom: 18px;
}

.constitucion-title {
  color: #fff;
  font-weight: 700;
  margin: 0;
}

.constitucion-subtitle {
  color: #e5e7eb;
  font-size: 0.93rem;
}

.form-card {
  background: #ffffff;
  border: 1px solid #e3e7ee;
  border-radius: 14px;
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.05);
  padding: 16px;
}

.constitucion-type {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.type-option {
  border: 1px solid #dce1e8;
  border-radius: 10px;
  display: flex;
  gap: 10px;
  padding: 13px;
  cursor: pointer;
  background: #ffffff;
}

.type-option.active {
  border-color: #2563eb;
  background: #eef5ff;
}

.type-option input {
  margin-top: 3px;
}

.type-option strong,
.type-option small {
  display: block;
}

.type-option small {
  color: #64748b;
  line-height: 1.35;
}

.section-caption {
  color: #111827;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.form-label {
  color: #374151;
  font-size: 0.88rem;
  font-weight: 700;
}

.form-control {
  border-color: #dce1e8;
  border-radius: 9px;
  min-height: 38px;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 18px;
}

.constitucion-save-btn {
  border-radius: 10px;
  min-height: 38px;
  padding-inline: 14px;
  font-weight: 600;
}

.loading-shell {
  color: #4b5563;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-weight: 600;
  min-height: 120px;
}

@media (max-width: 768px) {
  .constitucion-type {
    grid-template-columns: 1fr;
  }
}
</style>
